// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CustomerdataModel from '../../model/customerdata-model';
import CustomerdataDTO from '../dto/customerdata-dto';
import dtoSchema from '../schemas/customerdata-schema';
import AlrModel from '../../model/alr-model';

export default abstract class CustomerdataModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CustomerdataDTO>) {
    super();
    if (data) {
      this.alr = data.alr ? AlrModel.toModel(data.alr) : undefined;
      this.doms = data.doms ?? undefined;
      this.loc = data.loc ?? undefined;
      this.name = data.name;
      this.tags = data.tags ?? undefined;
    }
  }
  /**
  */
  alr?: AlrModel;
  /**
  */
  doms?: any[];
  /**
  */
  loc?: unknown;
  /**
  * @minimum 1
  */
  name?: string;
  /**
  */
  tags?: any[];

  static toModel(dto: DeepPartial<CustomerdataDTO>): CustomerdataModel;
  static toModel(dto: DeepPartial<CustomerdataDTO> | undefined | null): CustomerdataModel | undefined;
  static toModel(dto: DeepPartial<CustomerdataDTO> | undefined | null): CustomerdataModel | undefined {
    return dto ? new CustomerdataModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CustomerdataModel> | CustomerdataModel): CustomerdataDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      alr: unwrapped.alr,
      doms: unwrapped.doms,
      loc: unwrapped.loc,
      name: unwrapped.name,
      tags: unwrapped.tags,
    } as CustomerdataDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for CustomerdataModel, can not map to CustomerdataDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
